import { useTranslation } from 'react-i18next';
import { STATUS_TONE } from '../../utils/pipelineTasks';

/* A pipeline task's status as a small pill, on the theme's tones only. */
export default function PipelineStatus({ status }) {
  const { t } = useTranslation('pipeline');
  const tone = STATUS_TONE[status] || 'neutral';
  const style = tone === 'neutral'
    ? { background: 'var(--c-surface)', color: 'var(--c-text-muted-fg)', border: '1px solid var(--c-border)' }
    : { background: `var(--c-${tone}-soft)`, color: `var(--c-${tone}-fg)`, border: '1px solid transparent' };
  return (
    <span data-testid="pipeline-status" data-status={status}
      style={{ ...style, display: 'inline-block', borderRadius: 999, padding: '1px 10px', fontSize: 12,
        whiteSpace: 'nowrap' }}>
      {t(`status.${status}`, { defaultValue: status })}
    </span>
  );
}
